const TAG = 'current-time'

export function defineCurrentTime(): void {
  if (typeof window === 'undefined' || window.customElements.get(TAG)) return

  class CurrentTimeElement extends HTMLElement {
    private timer?: number
    private readonly formatter = new Intl.DateTimeFormat(undefined, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })

    constructor() {
      super()
      this.attachShadow({ mode: 'open' })
    }

    connectedCallback() {
      const root = this.shadowRoot
      if (!root) return
      if (!root.firstChild) {
        root.innerHTML = `
          <style>
            :host { display: inline-flex; }
            time {
              display: inline-flex; align-items: center; border: 1px solid var(--rich-time-border, #cbd5e1);
              border-radius: var(--rich-time-radius, 4px); background: var(--rich-time-bg, #f8fafc);
              color: var(--rich-time-color, #26323d); padding: 3px 7px;
              font: var(--rich-time-font, 600 0.9em ui-monospace, SFMono-Regular, Consolas, monospace);
              font-variant-numeric: tabular-nums;
            }
          </style>
          <time role="timer" aria-live="off"></time>`
      }
      window.clearInterval(this.timer)
      this.updateTime()
      this.timer = window.setInterval(() => this.updateTime(), 1000)
    }

    disconnectedCallback() {
      window.clearInterval(this.timer)
    }

    private updateTime() {
      const node = this.shadowRoot?.querySelector<HTMLTimeElement>('time')
      if (!node) return
      const now = new Date()
      node.dateTime = now.toISOString()
      node.textContent = this.formatter.format(now)
    }
  }

  window.customElements.define(TAG, CurrentTimeElement)
}
